

export const localeToCurrency = (args) =>  {
    switch (args) {
        case "en":
            return "USD";
        case "ko":
            return "KRW";
    }

    return '';
}
